module.exports = __webpack_public_path__ + "static/media/Background-Left.7c63820c.jpg";